// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1--lG","textarea":"styles_textarea__DlZvA"};